if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        if (this.elements.viewer) {
          this.elements.viewer.addEventListener(
            "slideChanged",
            debounce(this.onSlideChanged.bind(this), 500)
          );
        }
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            const button = mediaToSwitch.querySelector("button");
            if (button) {
              button.addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
            }
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");
        if (!activeMedia) {
          return;
        }
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia?.classList?.add("is-active");

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: "smooth" });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}

// Mobile scroll snap for product media gallery
(function () {
  function isMobile() {
    return window.innerWidth <= 768;
  }
  function enableMobileScrollSnap() {
    if (!isMobile()) return;
    var gallery = document.querySelector(".product__media-list");
    if (!gallery) return;
    let scrollTimeout;
    let isScrollingHorizontally = false;
    let hasScrolled = false;
    let touchStartX = 0;
    let touchStartY = 0;

    // Remove any previous listeners to avoid duplicates on resize
    if (gallery._snapListener) {
      gallery.removeEventListener("scroll", gallery._snapListener);
    }
    if (gallery._touchStartListener) {
      gallery.removeEventListener("touchstart", gallery._touchStartListener);
    }
    if (gallery._touchMoveListener) {
      gallery.removeEventListener("touchmove", gallery._touchMoveListener);
    }
    if (gallery._touchEndListener) {
      gallery.removeEventListener("touchend", gallery._touchEndListener);
    }

    // Track touch start to determine scroll direction
    gallery._touchStartListener = function (e) {
      isScrollingHorizontally = false;
      hasScrolled = false;
      if (e.touches.length === 1) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }
    };

    gallery._touchMoveListener = function (e) {
      if (e.touches.length === 1) {
        const touch = e.touches[0];
        const deltaX = Math.abs(touch.clientX - touchStartX);
        const deltaY = Math.abs(touch.clientY - touchStartY);

        // Only consider it scrolling if moved more than 10px
        if (deltaX > 10 || deltaY > 10) {
          hasScrolled = true;

          if (deltaX > deltaY) {
            isScrollingHorizontally = true;
          } else {
            isScrollingHorizontally = false;
          }
        }

        gallery._lastTouchX = touch.clientX;
        gallery._lastTouchY = touch.clientY;
      }
    };

    gallery._touchEndListener = function (e) {
      // CSS scroll-snap handles snapping; only update counter after browser has snapped
      if (!isScrollingHorizontally || !hasScrolled) return;
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        const items = Array.from(gallery.children);
        const scrollLeft = gallery.scrollLeft;
        let closestIndex = 0;
        let minDiff = Infinity;
        items.forEach(function (item, i) {
          const diff = Math.abs(item.offsetLeft - scrollLeft);
          if (diff < minDiff) {
            minDiff = diff;
            closestIndex = i;
          }
        });
        const counter = document.querySelector(".current_image");
        if (counter) counter.textContent = closestIndex + 1;
      }, 50);
    };

    gallery._snapListener = function () {
      // Only update counter for horizontal scrolling, snapping handled by touchend
      if (!isScrollingHorizontally) return;

      // Update counter in real-time during scroll
      const items = Array.from(gallery.children);
      const scrollLeft = gallery.scrollLeft;
      let closestIndex = 0;
      let minDiff = Infinity;
      items.forEach((item, i) => {
        const itemLeft = item.offsetLeft;
        const diff = Math.abs(itemLeft - scrollLeft);
        if (diff < minDiff) {
          minDiff = diff;
          closestIndex = i;
        }
      });

      // Update the image counter in real-time
      const counter = document.querySelector(".current_image");
      if (counter) {
        counter.textContent = closestIndex + 1;
      }
    };

    if (gallery) {
      gallery.addEventListener("touchstart", gallery._touchStartListener);
      gallery.addEventListener("touchmove", gallery._touchMoveListener);
      gallery.addEventListener("touchend", gallery._touchEndListener);
      gallery.addEventListener("scroll", gallery._snapListener);
    }
  }

  document.addEventListener("DOMContentLoaded", enableMobileScrollSnap);
  window.addEventListener("resize", enableMobileScrollSnap);
})();
